import type {RGB} from '@Utils/color.util';

export const DEFAULT_PRESETS: Array<RGB> = [
  [0, 0, 0],
  [84, 84, 84],
  [161, 161, 161],
  [217, 217, 217],
  [255, 255, 255],
  [146, 110, 97],
  [240, 79, 79],
  [251, 151, 89],
  [249, 184, 87],
  [250, 217, 86],
  [82, 219, 169],
  [12, 190, 104],
  [79, 228, 234],
  [51, 176, 248],
  [69, 101, 247],
  [7, 79, 175],
  [138, 85, 243],
  [213, 113, 242],
  [246, 99, 189],
];
